import { render, staticRenderFns } from "./maintenance.vue?vue&type=template&id=9c9dab44&"
import script from "./maintenance.vue?vue&type=script&lang=ts&"
export * from "./maintenance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./maintenance.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports